var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoRightBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(0.222 0)",
    fill: "none",
    stroke: "#089dd4",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.222 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(-45.778 0)",
    fill: "#089dd4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.222 0)",
    fill: "none",
    stroke: "#089dd4",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M805.665,240.94l4.84,4.841-4.84,4.841",
    transform: "translate(-784.091 -222.697)",
    fill: "none",
    stroke: "#089dd4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRightBlue);
export default __webpack_public_path__ + "static/media/ico-right-blue.3e3f6accc1ef6882bc3c9d48ec0ac94d.svg";
export { ForwardRef as ReactComponent };